import { render, staticRenderFns } from "./ReceiverList.vue?vue&type=template&id=eed11b2e&"
import script from "./ReceiverList.vue?vue&type=script&lang=ts&"
export * from "./ReceiverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports